import React, { useState,useEffect } from "react";
import { AiOutlineCaretUp, AiOutlineCaretDown } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import assetcapture from "../../images/asset capture.png";
import newtags from "../../images/new asset.png";
import assetprinting from "../../images/asset for printing.png";
import assetverified from "../../images/asset verification.png";
import assetmovement from "../../images/asset movement.png";
import assetcustodian from "../../images/asset by custodian.png";
import assetlocation from "../../images/asset by locations.png";
import adminpanel from "../../images/admin panel.png";
import logout1 from "../../images/log out.png";
import findasset from "../../images/find asset.png";
import transaction from "../../images/asset by inventory.png";
import assetverification from "../../images/verified asset.png";
import GtrackLogo from "../../images/NEW FATS LOGO.png";
import memberprofile from "../../images/memberprofile.png"
import i18ns from "../../i18n";
import LanguageSwitcher from '../../switer'
import userRequest from "../../utils/userRequest";
// images
// import { Images } from "../../../PRoute/assets/Index";

function Sidebarfats() {
  const [openLink, setOpenLink] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const NavLinks = [
    // {
    //   title: t("Dashboard"),
    //   icon: Dashboard,
    //   link: "/dashboard",
    // },
    {
      title: t("Asset Capture"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685203/asset_capture_lagncg.png",
      link: "/member/userdetails",
    },
    {
      title: t("New Asset (Generate Tags)"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685246/new_asset_svq7ii.png",
      link: "/member/newasset",
    },
    {
      title: t("Asset for Printing"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685246/new_asset_svq7ii.png",
      link: "/member/userprinting",
    },
    {
      title: t("Verified Assets"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685329/asset_verification_wmefg6.png",
      link: "/member/verifiedasset",
    },
    {
      title: t("Asset Movement"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685329/asset_movement_hrjpis.png",
      link: "/member/movement",
    },
    {
      title: t("Asset By Custodian"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685325/asset_by_custodian_aukvmm.png",
      link: "/member/cust",
    },
    {
      title: t("Asset by locations"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685326/asset_by_locations_scunfn.png",
      link: "/member/location",
    },

    {
      title: t("Assets Inventory"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685325/asset_by_inventory_hibawy.png",
      // link: "/location",
    },
    {
      title: t("Admin Panel"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726679091/admin_panel_l5jzzp.png",
      link: "/admin-login",
      target: "_blank",
    },

    {
      title: t("Find Asset"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685330/find_asset_kfgsru.png",
      link: "/member/movement",
    },
    {
      title: t("Asset Verification"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685562/verified_asset_pbxnkk.png",
      link: "/member/verify",
    },
    {
      title: t("Log-out"),
      icon: "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685330/log_out_thvpab.png",
      link: "/userlogin",
    },
  ];

  const handleClick = (link) => {
       if (link.title === t("Log-out")) {
         // Clear session storage when user logs out
         sessionStorage.removeItem("userToken");
         navigate(link.link); // Redirect to login page
         return;
       }
    if (link.target === "_blank") {
      window.open(link.link, "_blank");
    } else {
      //   navigate(link.link);
      if (link.sublinks) {
        setOpenLink(openLink === link.title ? null : link.title);
      } else {
        navigate(link.link);
      }
    }
  };

  const [roles, setRoles] = useState([]);
  const [error, setError] = useState(null);

    useEffect(() => {
    // new.get('/userRoles')
    userRequest.get("/userRoles")
      .then(response => {
        // this will return the list of roles id which is assigned to the user and we can use that to show the menu items
        setRoles(response?.data ?? []);
      })
      .catch(error => {
        setError(error?.response?.data?.message ?? "Something went wrong");
        console.error(error);

      });
  }, []);

 const handleNavigation = (tabName) => {
   //  check if the user has the role to access the tab and then navigate to the tab
   switch (tabName) {
     case "assetCapture":
       if (roles.includes(9) || roles.includes(1)) {
         navigate("/member/userdetails");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "generateTags":
       if (roles.includes(2) || roles.includes(1)) {
         navigate("/member/newasset");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "assetForPrinting":
       if (roles.includes(3) || roles.includes(1)) {
         navigate("/member/userprinting");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "verifiedAssets":
       if (roles.includes(4) || roles.includes(1)) {
         navigate("/member/verifiedasset");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "custodian":
       if (roles.includes(5) || roles.includes(1)) {
         navigate("/member/cust");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "location":
       if (roles.includes(6) || roles.includes(1)) {
         navigate("/member/location");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "assetInventory":
       if (roles.includes(7) || roles.includes(1)) {
         // navigate('#')
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "verify":
       if (roles.includes(8) || roles.includes(1)) {
         navigate("/member/verify");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "admin":
       if (roles.includes(1) || roles.includes(1)) {
         navigate("/member/admin");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     case "findAsset":
       if (roles.includes(10) || roles.includes(1)) {
         navigate('/member/findasset')
       } else {
         setError("You don't have access to this tab");
       }
     case "assetMovement":
       if (roles.includes(11) || roles.includes(1)) {
         navigate("/member/movement");
       } else {
         setError("You don't have access to this tab");
       }
       break;
     default:
       break;
   }
 };



  return (
    <>
      <div
        className={` bg-[#1E3B8B] text-white ${
          i18n.language === "ar" ? "sm:mr-72" : "sm:ml-72"
        }`}
      >
        <div
          className={`flex  justify-between items-center flex-wrap ${
            i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
          }`}
        >
          <button
            className={`absolute top-4  sm:hidden smm:hidden left-4`}
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {/* <GiHamburgerMenu className="text-2xl" /> */}
            <span className="sr-only">(t{"Open sidebar"})</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
              ></path>
            </svg>
          </button>
          <p
            className={`sm:text-2xl  sm:py-0 py-2 sm:px-0 px-3 my-auto  font-medium ${
              i18n.language === "ar" ? "mr-5" : "ml-5"
            }`}
          >
            {t("FATS")}
          </p>
          <div
            className={`flex justify-end items-end my-auto px-4 ${
              i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
            }`}
          >
            <span className="w-full my-auto ">
              <I18nextProvider i18n={i18ns}>
                <LanguageSwitcher />
              </I18nextProvider>
            </span>
            <div
              className="cursor-pointer my-auto"
              onClick={() => navigate("/updateprofile")}
            >
              <img
                src={
                  "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685331/memberprofile_ozo9lw.png"
                }
                className="h-7 w-7  bg-white rounded-full"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex ">
        <nav
          className={`fixed top-0 z-[40] h-screen  pb-4 overflow-y-auto bg-[#1E3B8B] text-white transition-transform ${
            isSidebarOpen
              ? "translate-x-0"
              : i18n.language === "ar"
              ? "translate-x-full"
              : "-translate-x-full"
          } sm:translate-x-0 ${i18n.language === "ar" ? "right-0" : "left-0"}`}
        >
          <img
            onClick={() => navigate("/member/assets")}
            src={
              "https://res.cloudinary.com/dm7thv7g8/image/upload/v1726685637/NEW_FATS_LOGO_zqai9f.png"
            }
            alt="logo"
            className="w-full h-32  mx-auto object-contain cursor-pointer"
          />
          {NavLinks.map((link, index) => (
            <div key={index}>
              <button
                className="flex w-full items-center justify-between px-4 py-2 rounded-md gap-3 hover:bg-white hover:text-gray-900"
                style={{ direction: i18n.language == "ar" ? "rtl" : "ltr" }}
                onClick={() => handleClick(link)}
              >
                <div className="flex  items-center gap-1">
                  <img
                    src={link.icon}
                    alt="logo"
                    className=" w-10 h-10 object-contain mr-3"
                  />
                  {link.title}
                </div>
                {link.sublinks &&
                  (openLink === link.title ? (
                    <AiOutlineCaretUp />
                  ) : (
                    <AiOutlineCaretDown />
                  ))}
              </button>
              {link.sublinks && openLink === link.title && (
                <div className="pl-5 space-y-2 py-2 ">
                  {link.sublinks.map((sublink) => (
                    <button
                      onClick={() => navigate(sublink.link)}
                      key={sublink}
                      className={`block py-2 w-full rounded-md hover:bg-white hover:text-gray-900
                    ${
                      i18n.language == "ar"
                        ? "pr-2 text-end"
                        : "pl-2 text-start"
                    }  
                    `}
                    >
                      {sublink.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>
      {/* </div> */}

      {/* <div
        className={`fixed top-0 z-[40] h-screen  pb-4 overflow-y-auto bg-[#1E3B8B] text-white transition-transform ${
          isSidebarOpen
            ? "translate-x-0"
            : i18n.language === "ar"
            ? "translate-x-full"
            : "-translate-x-full"
        } sm:translate-x-0 ${i18n.language === "ar" ? "right-0" : "left-0"}`}
      >
        <div class="flex flex-col justify-between">
          <ul class="flex flex-col py-4 space-y-5">
            <li
              onClick={() => handleNavigation("assetCapture")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetcapture} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Asset Capture
              </span>
            </li>
            <li
              onClick={() => handleNavigation("generateTags")}
              // onClick={() =>
              //   navigate('/newasset') }
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={newtags} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                New Asset (Generate Tags)
              </span>
            </li>
            <li
              // onClick={() => navigate('/userprinting')}
              onClick={() => handleNavigation("assetForPrinting")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetprinting} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Asset for Printing
              </span>
            </li>
            <li
              // onClick={() => navigate('/verifiedasset')}
              onClick={() => handleNavigation("verifiedAssets")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetverified} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Verified Assets
              </span>
            </li>
            <li
              // onClick={() => navigate('/movement')}
              onClick={() => handleNavigation("assetMovement")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetmovement} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Asset Movement
              </span>
            </li>
            <li
              //  onClick={() => navigate('/cust')}
              onClick={() => handleNavigation("custodian")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetcustodian} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Asset By Custodian
              </span>
            </li>
            <li
              // onClick={() => navigate('/location')}
              onClick={() => handleNavigation("location")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetlocation} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Asset by locations
              </span>
            </li>
            <li onClick={() => handleNavigation("assetInventory")}>
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={transaction} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Assets Inventory
              </span>
            </li>
            <li
              className="cursor-pointer"
              // onClick={() => navigate('/admin')}
              onClick={() => handleNavigation("admin")}
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={adminpanel} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Admin Panel
              </span>
            </li>
            <li
              onClick={() => navigate("/userlogin")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={logout1} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Log-out
              </span>
            </li>
            <li onClick={() => handleNavigation("findAsset")}>
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={findasset} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Find Asset
              </span>
            </li>
            <li
              // onClick={() => navigate('/verify')}
              onClick={() => handleNavigation("verify")}
              className="cursor-pointer"
            >
              <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                <img src={assetverification} className="h-5 w-5" alt="" />
              </span>
              <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">
                Asset Verification
              </span>
            </li>
          </ul>
        </div>
      </div> */}
    </>
  );
}

export default Sidebarfats;
